<template>
  <div class="passo5">
    <div class="container wp-box section section-artigo with-box">
      <h2>Soluções para você</h2>

      <div class="timeline">
        <div id="timeline-wrap">
          <div id="timeline"></div>
          <div class="marker mfirst timeline-icon one active">1</div>
          <div class="marker m2 timeline-icon two active">2</div>
          <div class="marker m3 timeline-icon three active">3</div>
          <div class="marker m4 timeline-icon four active">4</div>
          <div class="marker m5 timeline-icon five active">5</div>
          <div class="marker mlast timeline-icon six">6</div>
        </div>
      </div>
    </div>

    <div class="container wp-box section section-artigo with-box">
      
      <div class="row">
        <div class="colsm-12">
          <p>Para apresentar a melhor solução, precisamos saber se você possui um desses bens:</p>
        </div>
      </div>
      

      <div class="row">
        <div class="colsm-6">
          <div class="control-item">
            <ul>
              <li v-for="(obj, index) in garantias" :key="index">
                <input type="checkbox" class="font-icon" :id="obj.iID_Garantia"  :value="obj.iID_Garantia" v-model.lazy="flag[obj.iID_Garantia]" @change="check($event)" />
                <label :for="obj.iID_Garantia" class="opcao-radio">{{obj.vGarantia}}</label>
                <div class="colsm-12">
                  <div class="control-item valor-bens" v-if="flag[obj.iID_Garantia] && obj.iID_Garantia != 6">
                    <label class="label-d">Valor (R$):</label>
                    <money name="valor-imovel" :value="valores[obj.iID_Garantia]" class="field-d" v-bind="money" @blur.native="checkValor($event, obj.iID_Garantia)"></money>
                    <small class="form-text text-muted">{{ errors.first('valor-imovel') }}</small>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
     <div class="row">
        <div class="colsm-8">
          <small class="form-text text-muted" v-show="error">Informe o valor de todos os bens.</small>
          <small class="form-text text-muted" v-if="erroApi">Erro de comunicação com o servidor. Tente novamente mais tarde.</small>
        </div>
      </div>
      <div class="row">
        <div class="colsm-8">
          <a class="btn blue" @click="validarAvancar(dados)">Próxima Etapa</a> <span class="etapa-anterior">ou <router-link :to="{name: 'passo-quatro', params: {dados}}" >volte à etapa anterior</router-link></span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {Money} from 'v-money'
import axios from 'axios';

export default {
  components: {Money},
  name: 'passo5',
  data: function() {
    return {
      garantias: null,
      opcoes: [],
      tags: [],
      valor_imovel: 0,
      imovel: 0,
      valor_investimento: 0,
      investimento: 0,
      valor_carro: 0,
      carro: 0,
      nenhuma: 0,
      error: null,
      checado: null,
      erroApi: false,
      flag: [],
      valores: [],
      tags: [],
      dados: {

      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true
      },
      urlApi: process.env.VUE_APP_URL_API
    };
  },
  methods: {
    validarAvancar(dados) {

    var _this = this;

    _this.tags = [];

    if(this.opcoes.length == 0){
        this.opcoes.push({ "iID_Garantia": 6, "mValor": 0});
        this.tags.push({ "iID_Garantia": 6, "mValor": 0, vGarantia: "Nenhuma"});
      }


    for(var i=0; i<this.opcoes.length; i++){
      if(this.opcoes[i].iID_Garantia != 6 && this.opcoes[i].mValor == 0){
        this.error = true;
      } else {
        this.error = false;
        this.tags.push({ "iID_Garantia": this.opcoes[i].iID_Garantia, "mValor": this.opcoes[i].mValor, vGarantia: _this.garantias.find(x => x.iID_Garantia === this.opcoes[i].iID_Garantia).vGarantia});
        
      }
    }

    if(!this.error){
      this.dados.Visita_Dados_Garantias = this.opcoes;

    _this.dados.iPasso_Simulador = 5;
      this.$loading(true);
        axios.post(_this.urlApi + 'Visita_Dados_PF/' + _this.dados.iID_Visita, _this.dados)
          .then(function (response) {
            console.log(_this.dados.Visita_Dados_Garantias);
            try{
              dataLayer.push({
                'passoSimulador': 'Passo5',
                'garantias': _this.tags,
                'event': 'proximoPasso',
                'tipo': 'PF'
              });
            } catch(error){
              console.error(error);
            }

            _this.$router.push({name:'passo-seis', params:{dados}});

            _this.$loading(false);
          })
          .catch(function (error) {
            _this.erroApi = true;
            _this.$loading(false);
          });
    }
    


    },
    check(e){
      var _this = this;
      if(e.target.checked){
        this.opcoes.push({iID_Garantia: parseInt(e.target.value), mValor: 0});
        this.flag[e.target.value] = true;

      } else {
        let pos = this.opcoes.map(function(event) { return event.iID_Garantia; }).indexOf(parseInt(e.target.value));
        this.$delete(this.opcoes, pos);
        this.flag[e.target.value] = false;
      }
    },
    checkValor(e, id){
      var _this = this;
      let pos = this.opcoes.map(function(event) { return event.iID_Garantia; }).indexOf(id);
      this.$delete(this.opcoes, pos);

      var bruto = e.target.value.replace(".", "").replace(",", ".");
      this.opcoes.push({iID_Garantia: id, mValor: parseFloat(bruto)});
    }
  },
  created: function(){
    this.$loading(true)
    this.dados = this.$route.params.dados;
    this.opcoes = this.dados.Visita_Dados_Garantias;
    let i = 0;

    for(i=0; i<this.opcoes.length; i++){
      this.flag[this.opcoes[i].iID_Garantia] = true;
      this.valores[this.opcoes[i].iID_Garantia] = this.opcoes[i].mValor;
    }

    axios
      .get(this.urlApi + 'Garantias')
      .then(response => {
          this.garantias = response.data
          this.$loading(false);
        }
      )
      .catch(error => {
        
        this.$loading(false);
      })
  }
}
</script>

<style scoped lang="scss">
.valor-bens{
  margin-left: 25px;
  margin-top: 10px;
  margin-bottom: 20px;
  width: 100%;
}


/*  TABLET */
@media only screen and (max-width: 1026px) {

}

@media only screen and (max-width: 770px){


}
/* MOBILE */

/* IPHONE 6 PLUS*/
@media only screen and (max-width: 645px) {


}
/* IPHONE 6 */
@media only screen and (max-width: 480px) {
  .field-d{
    width: 70%;
  }
  .valor-bens{
    margin-left: 14px;
  }

}

/* IPHONE 5*/
@media only screen and (max-width: 328px) {

}
</style>